module.exports = __webpack_public_path__ + "img/amx-2.8b501c3f.webp";